// ** IMPORTANT **: Keep in sync with functions/src/index.ts/parseSpecialNumbers
const parseSpecialNumbers = <T = unknown>(json: string): T => JSON.parse(json, (_k, v) => {
    if (typeof v === 'string' && (v === 'Infinity' || v === '-Infinity' || v === 'NaN')) {
        return Number(v); // Infinity, -Infinity, or NaN
    }
    return v;
});

export default parseSpecialNumbers;
